import React, { createContext } from 'react'
import RootStore from 'store/Root'

export const StoreContext = createContext(RootStore)

export const StoreProvider = ({
  children,
  store
}) => {
  return (
    <StoreContext.Provider value={store}>{children}</StoreContext.Provider>
  )
}